import React from 'react';
import { Container, Grid, Box, Typography, Button, Stack } from '@mui/material';
import Hero from '../components/Hero';
import ProcessSteps from '../components/ProcessSteps';
import Testimonials from '../components/Testimonials';
import ServiceCard from '../components/ServiceCard';
import ContactForm from '../components/ContactForm';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import services from '../content_stub/services_content.js';
import heroBg from '../assets/images/hero-home.png';
import heroAbout from '../assets/images/hero-about.jpg';

export default function Home() {
  const m = meta.home;
  const topServices = services.slice(0, 8);
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero
        title="HVAC Repair & Installation in Bloomington IN"
        // subtitle="24/7 emergency response. EPA & NATE certified technicians. Air conditioning, furnaces, heat pumps, boilers, duct cleaning, and indoor air quality."
        subtitle="24/7 emergency response by EPA & NATE certified technicians. From ACs and furnaces to duct cleaning — we deliver fast, fair, and lasting results with affordable preventive maintenance plans."
        ctaText="Request Service"
        ctaLink="/book"
        bgImage={heroBg}
      />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <Typography variant="h2" gutterBottom>Why Choose Rite HVAC Services</Typography>
            <Typography paragraph>
              We help Bloomington homeowners and facility managers solve heating and cooling problems quickly and permanently.
              Our team pairs high-quality workmanship with clear communication and transparent pricing—no guesswork.
            </Typography>
            <ul>
              <li><strong>Experienced technicians:</strong> EPA & NATE certified pros who diagnose issues right the first time.</li>
              <li><strong>24/7 service:</strong> Around-the-clock coverage for urgent breakdowns and unsafe conditions.</li>
              <li><strong>Energy efficiency:</strong> Recommendations that reduce utility costs without sacrificing comfort.</li>
              <li><strong>Transparent pricing:</strong> Written quotes and options before work begins.</li>
            </ul>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Button variant="contained" href="/book">Book Appointment</Button>
              <Button variant="outlined" href="/services">Explore Services</Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box component="img" src={heroAbout} alt="Technicians" sx={{ width: '100%', borderRadius: 2, border: '1px solid #eee' }} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 8 }}>
          <Typography variant="h2" gutterBottom>Our HVAC Process</Typography>
          <ProcessSteps />
        </Box>

        <Box sx={{ mt: 8 }}>
          <Typography variant="h2" gutterBottom>Popular Services</Typography>
          <Grid container spacing={3}>
            {topServices.map(s => (
              <Grid item xs={12} md={3} key={s.slug}><ServiceCard service={s} /></Grid>
            ))}
          </Grid>
        </Box>

        {/* <Box sx={{ mt: 8 }}>
          <Typography variant="h2" gutterBottom>Recent Projects in Bloomington IN</Typography>
          <Grid container spacing={3}>
            {[1,2,3,4,5,6].map(i => (
              <Grid item xs={12} md={4} key={i}>
                <Box component="img" src={`/src/assets/images/gallery-${String(i).padStart(2,'0')}.svg`} alt={`Project ${i}`} sx={{ width: '100%', borderRadius: 2, border:'1px solid #eee' }} />
                <Typography variant="subtitle1" sx={{ mt: 1 }}>Project {i}: High-efficiency retrofit</Typography>
                <Typography variant="body2" color="text.secondary">Bloomington, Indiana — replaced aging equipment with inverter-driven systems and sealed visible duct leaks.</Typography>
              </Grid>
            ))}
          </Grid>
        </Box> */}

        <Box sx={{ mt: 8 }}>
          <Typography variant="h2" gutterBottom>What Our Clients Say</Typography>
          <Testimonials />
        </Box>

       <Box sx={{ mt: 8 }}>
  <Typography variant="h2" gutterBottom>
    Service Area
  </Typography>
  <Typography color="text.secondary" paragraph>
    We proudly serve Bloomington IN and nearby areas: Ellettsville, Bedford, Martinsville, and Spencer.
  </Typography>

  <Box
    component="iframe"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3094.233465052612!2d-86.53690318462588!3d39.16532697947405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886c63d25ad1f2ff%3A0x8b55e03468c00a01!2sBloomington%2C%20IN!5e0!3m2!1sen!2sin!4v1707896000000!5m2!1sen!2sin"
    width="100%"
    height="400"
    style={{ border: 0, borderRadius: '8px' }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</Box>


        <Box sx={{ mt: 8 }}>
          <Typography variant="h2" gutterBottom>Quick Contact</Typography>
          <ContactForm compact />
        </Box>
      </Container>
    </Box>
  );
}
